export default __webpack_public_path__ + "static/media/5.ad5b2bfd.png";